import { useParams } from "react-router-dom";
import LigaTV from "../components/widgetsTV/ligaTV/ligaTV";


export default function LigaTVPage() {
  const { idligas } = useParams();

  // Validar que solo se tomen máximo 2 IDs separados por coma
  const getLimitedIdligas = (idsString) => {
    if (!idsString) return idsString;
    
    const ids = idsString.split(",");
    // Tomar máximo los dos primeros IDs
    return ids.slice(0, 2).join(",");
  };

  const limitedIdligas = getLimitedIdligas(idligas);

  return (
    <LigaTV idligas={limitedIdligas} />
  );
}